function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_18_copy",
  "data-name": "18 copy"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m63.618 62-2.718-5.447a1 1 0 0 0 -.9-.553h-1v-30h3v-2h-3v-19a5.006 5.006 0 0 0 -5-5h-14a5.006 5.006 0 0 0 -5 5v1a3 3 0 0 0 -3 3v1h-5a3 3 0 0 0 -3 3v2a1 1 0 0 0 1 1h15v-2h-14v-1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v1h-4v2h5a1 1 0 0 0 1-1v-2a3 3 0 0 0 -3-3h-5v-1a3 3 0 0 0 -3-3v-1a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v19h-5v2h5v14h-3v-2h-2v6h2v-2h3v14h-1a1 1 0 0 0 -.9.553l-2.718 5.447h-52.382v2h64v-2zm-25.618-53v1h-4v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zm18.618 49h2.764l2 4h-6.764z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29 18h2v4h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29 24h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29 34h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m37 34h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29 28h2v4h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m33 22h2v4h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m33 28h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m33 32h2v6h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m41 22h2v4h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m41 28h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m41 32h2v6h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m37 18h2v4h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m37 24h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m37 28h2v4h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m45 34h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m45 18h2v4h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m45 24h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m45 28h2v4h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m41 18h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m33 18h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25 22h2v4h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25 28h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25 32h2v6h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25 18h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m2 37.987v19.013a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-19.1l2-.013v2.113h2v-6h-2v1.882l-18.006.118.012 2zm2 12.013h10v1h-10zm0 6v-3h10v3zm10-8h-10v-10.026l10-.066z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10 29c4.486 0 8-5.271 8-12s-3.514-12-8-12-8 5.271-8 12 3.514 12 8 12zm0-22c3.252 0 6 4.579 6 10s-2.748 10-6 10-6-4.579-6-10 2.748-10 6-10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.095 13.5h7.81v2h-7.81z",
  transform: "matrix(.768 -.64 .64 .768 -7.197 9.122)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7.095 18.5h7.81v2h-7.81z",
  transform: "matrix(.768 -.64 .64 .768 -9.934 11.562)"
})));

function SvgBathroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Line_expand",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Line expand",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroom);
export default __webpack_public_path__ + "static/media/bathroom.9821d820.svg";
export { ForwardRef as ReactComponent };